// Screens ask for Inter by that name (accounting, applicants, the sidebar, the report library). Google's stylesheet used to
// answer; the app now names its own bundled @fontsource-variable/inter files "Inter", subset by subset, so no screen loads
// a font from Google and none falls back to the system font. The files are the ones 'Inter Variable' already draws with.
import cyrillicExt from '@fontsource-variable/inter/files/inter-cyrillic-ext-wght-normal.woff2?url';
import cyrillic from '@fontsource-variable/inter/files/inter-cyrillic-wght-normal.woff2?url';
import greekExt from '@fontsource-variable/inter/files/inter-greek-ext-wght-normal.woff2?url';
import greek from '@fontsource-variable/inter/files/inter-greek-wght-normal.woff2?url';
import vietnamese from '@fontsource-variable/inter/files/inter-vietnamese-wght-normal.woff2?url';
import latinExt from '@fontsource-variable/inter/files/inter-latin-ext-wght-normal.woff2?url';
import latin from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url';

/** Each file with the unicode-range @fontsource-variable/inter's wght.css gives it. */
const SUBSETS: readonly [string, string][] = [
  [cyrillicExt, 'U+0460-052F,U+1C80-1C8A,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F'],
  [cyrillic, 'U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116'],
  [greekExt, 'U+1F00-1FFF'],
  [greek, 'U+0370-0377,U+037A-037F,U+0384-038A,U+038C,U+038E-03A1,U+03A3-03FF'],
  [vietnamese, 'U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB'],
  [latinExt, 'U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF'],
  [latin, 'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD'],
];

const ID = 'app-inter';

export function installInterFace(): void {
  if (document.getElementById(ID)) return;
  const style = document.createElement('style');
  style.id = ID;
  style.textContent = SUBSETS.map(([url, range]) => `@font-face{font-family:Inter;font-style:normal;font-weight:100 900;font-display:swap;src:url(${url}) format('woff2');unicode-range:${range}}`).join('');
  document.head.appendChild(style);
}
